"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileSelected = exports.HttpTransfer = void 0;
var HttpTransfer = /** @class */ (function () {
    function HttpTransfer(id, spec, files, status, options) {
        this.httpGatewayTransfer = true;
        this.recentPackets = [];
        this.uuid = id;
        this.status = status || 'initiating';
        this.add_time = new Date().toISOString();
        this.transfer_spec = spec;
        this.transport = 'http_gateway';
        if (options && typeof options === 'object' && options.serverUrlOverride) {
            this.serverUrlOverride = options.serverUrlOverride;
        }
        this.files = files.map(function (file) {
            return {
                lastModified: file.lastModified,
                name: file.name,
                size: file.size,
                type: file.type
            };
        });
        this.current_file = this.files[0] ? this.files[0].name : '';
    }
    HttpTransfer.prototype.setEndTime = function () {
        this.end_time = new Date().toISOString();
    };
    Object.defineProperty(HttpTransfer.prototype, "calculated_rate_kbps", {
        get: function () {
            if (this.recentPackets.length) {
                var timeBetweenLastPackets = this.recentPackets[this.recentPackets.length - 1].timeStamp - this.recentPackets[0].timeStamp;
                var bytesWrittenInLastPackets_1 = 0;
                this.recentPackets.forEach(function (packet) {
                    bytesWrittenInLastPackets_1 += packet.bytes;
                });
                if (timeBetweenLastPackets && bytesWrittenInLastPackets_1) {
                    return (((bytesWrittenInLastPackets_1 * 8) / (timeBetweenLastPackets / 1000000)) / 1000);
                }
            }
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    HttpTransfer.prototype.recentPacketTransfer = function (bytes) {
        if (this.recentPackets.length >= 5) {
            this.recentPackets.shift();
        }
        this.recentPackets.push({
            timeStamp: new Date().getTime() * 1000,
            bytes: bytes
        });
    };
    Object.defineProperty(HttpTransfer.prototype, "elapsed_usec", {
        get: function () {
            var endTime = this.end_time ? new Date(this.end_time).getTime() : new Date().getTime();
            return (endTime - new Date(this.add_time).getTime()) * 1000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpTransfer.prototype, "percentage", {
        get: function () {
            if (this.bytes_written > 0 && this.bytes_written <= this.bytes_expected) {
                return ((this.bytes_written / this.bytes_expected));
            }
            else if (this.bytes_written > this.bytes_expected) {
                return 1;
            }
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    return HttpTransfer;
}());
exports.HttpTransfer = HttpTransfer;
var FileSelected = /** @class */ (function () {
    function FileSelected(file) {
        this.name = file.name;
        this.size = file.size;
        this.type = file.type;
    }
    return FileSelected;
}());
exports.FileSelected = FileSelected;
